import { MasterSidebarItem } from '../../components/sidebar/sidebar.component';

export const sideBarItems: MasterSidebarItem[] = [
  {
    routeLink: '',
    icon: 'pi pi-home',
    label: 'Dashboard',
  },
  {
    routeLink: 'create-appointment',
    icon: 'pi pi-calendar',
    label: 'Book Appointments',
  },
  {
    routeLink: 'videos',
    icon: 'pi pi-video',
    label: 'Videos',
  },
  {
    routeLink: 'recipe-list',
    icon: 'pi pi-book',
    label: 'Recipes',

  },
  {
    routeLink: 'product-list',
    icon: 'pi pi-box',
    label: 'Buy Products',
  },
  {
    routeLink: 'manage-subscriptions',
    icon: 'pi pi-receipt',
    label: 'Manage Subscriptions',
  },
  {
    icon: 'pi pi-user',
    label: 'User Information',
    children: [
      {
        routeLink: 'profile',
        icon: 'pi pi-id-card',
        label: 'Profile',
      },
      {
        routeLink: 'my-appointments',
        icon: 'pi pi-calendar',
        label: 'My Appointments',
      },

      {
        routeLink: 'preassessment-history',
        icon: 'pi pi-list',
        label: 'My Pre-Assessments',
      },
      {
        routeLink: 'payment-history',
        icon: 'pi pi-wallet',
        label: 'Payment History',
      },
      {
        routeLink: 'diet-summary',
        icon: 'pi pi-apple',
        label: 'Diet Summary',
      },
      {
        routeLink: 'diet-logging',
        icon: 'pi pi-calendar-clock',
        label: 'Diet Logging',
      },
      {
        routeLink: 'manage-documents',
        icon: 'pi pi-file',
        label: 'Manage Documents',
      },
      {
        routeLink: 'manage-transactions',
        icon: 'pi pi-wallet',
        label: 'Manage Transactions',
      },
      {
        routeLink: 'manage-orders',
        icon: 'pi pi-shopping-cart',
        label: 'Manage Orders',
      },
    ],
  },
];
